import React, { FC, useEffect, useState } from "react";
import classNames from "classnames";
import Button from "../../../components/button/Button";
import {
  useReceiveNotificationsMutation,
  useSyncEmailsMutation,
  useUpdateEmailMutation,
} from "../../../slices/UserSlice";
import { useAppDispatch, useAppSelector } from "../../../redux/redux";
import { getUser } from "../../../services/AppService";
import { GlobalContext } from "../../../app/stateMachines/GlobalContext";
import * as Xstate from "@xstate/react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { Swiper } from "../../../components/swiper/Swiper";

type Props = {
  isActive: boolean;
  onClose: () => void;
  notifications?: boolean;
};
export const SyncModal: FC<Props> = ({ isActive, onClose, notifications }) => {
  const dispatch = useAppDispatch();
  const { userInfoService } = React.useContext(GlobalContext);
  const [userInfoState] = Xstate.useActor(userInfoService);
  const { userInfoByEmail } = userInfoState.context;
  const [syncEmails, { isSuccess, isError }] = useSyncEmailsMutation();
  const [receiveNotifications, { isSuccess: successNotifications }] =
    useReceiveNotificationsMutation();
  const [updateEmail] = useUpdateEmailMutation();

  const { user } = useAppSelector((state) => state.appReducer);

  const [isChecked, seIsChecked] = useState(user.syncEmails ?? true);
  const [isReceiveNotifications, setIsReceiveNotifications] = useState(
    user.receiveEmailNotification ?? true,
  );
  const [emailValue, setEmailValue] = useState(
    user.sendNotificationToEmail || user.nylasToken.email,
  );
  const onSubmit = () => {
    if (notifications) {
      if (isReceiveNotifications) {
        receiveNotifications({
          userId: user.id,
          receiveEmail: true,
        });
      } else {
        receiveNotifications({
          userId: user.id,
          receiveEmail: false,
        });
      }
      updateEmail({ email: emailValue, userId: user.id });
    } else {
      if (isChecked) {
        syncEmails({
          userId: user.id,
          syncEmail: true,
        });
      } else {
        syncEmails({
          userId: user.id,
          syncEmail: false,
        });
      }
    }
  };

  useEffect(() => {
    if (isSuccess) {
      dispatch(
        getUser({
          userId: `${userInfoByEmail?.id}`,
          orgId: `${userInfoByEmail?.org?.id}`,
        }),
      );
      onClose();
    }
  }, [isSuccess]);

  useEffect(() => {
    if (isError) {
      onClose();
    }
  }, [isError]);

  useEffect(() => {
    if (successNotifications) {
      dispatch(
        getUser({
          userId: `${userInfoByEmail?.id}`,
          orgId: `${userInfoByEmail?.org?.id}`,
        }),
      );
      onClose();
    }
  }, [successNotifications]);
  console.log(user);
  return (
    <div
      className={classNames("modal", isActive ? "modal-open" : "modal-close")}>
      <div
        className={classNames(
          "modal-box flex w-[440px] flex-col gap-2 p-0",
          notifications ? "h-fit pb-2" : "h-[300px]",
        )}>
        <div
          className={
            "flex items-center border-b border-gray-300 px-3 py-2 text-start text-base font-semibold"
          }>
          <div>Notifications Settings</div>
        </div>
        <div className={"flex flex-col items-start justify-between pl-3"}>
          <div className={"flex w-full justify-between text-base"}>
            {notifications
              ? "Email Notifications"
              : "Sync emails with client profiles and works"}
            {notifications ? (
              <div className={"pr-3"}>
                <Swiper
                  value={isReceiveNotifications}
                  onChange={() => {
                    if (isReceiveNotifications) {
                      setIsReceiveNotifications(false);
                    } else {
                      setIsReceiveNotifications(true);
                    }
                  }}
                  description={""}
                  descriptionPosition={"right"}
                />
              </div>
            ) : (
              <input
                type="checkbox"
                className={classNames(
                  "toggle toggle-accent mr-4",
                  isChecked
                    ? "border-[#7c66f0] bg-[#7c66f0]"
                    : "border-gray-300 bg-gray-300",
                )}
                onChange={(e) =>
                  e.target.checked ? seIsChecked(true) : seIsChecked(false)
                }
                checked={isChecked}
              />
            )}
          </div>
          <div className={"pb-2 text-sm"}>
            Receive email notifications for new activity
          </div>
        </div>
        {notifications ? (
          <div>
            <div className={"border-t border-gray-300 pl-3 pr-3"}>
              <div
                className={classNames(
                  "py-2 text-base",
                  !isReceiveNotifications && "text-gray-400",
                )}>
                Email Address
              </div>
              <div className={"pb-2"}>
                <input
                  disabled={!isReceiveNotifications}
                  className={classNames(
                    "input input-bordered h-[30px] w-[100%]",
                    !isReceiveNotifications && "border-gray-500 text-gray-500",
                  )}
                  value={emailValue}
                  onChange={(e) => setEmailValue(e.target.value)}
                />
              </div>
              <div
                className={classNames(
                  "pb-2 text-sm",
                  !isReceiveNotifications && "text-gray-400",
                )}>
                Notifications will be sent to this email
              </div>
            </div>
          </div>
        ) : (
          <div className={"px-3 text-sm"}>
            Enabling email sync will show incoming and outgoing emails in client
            <br />
            profiles and associated work items.
            <br />
            By disabling this feature you will still be able to see your emails
            here
            <br />
            but they will not be visible in client profiles and work items.
          </div>
        )}

        <div className={"flex justify-end gap-2 px-3"}>
          <button
            onClick={onClose}
            className={
              "flex h-[35px] w-full items-center justify-center rounded-lg border border-[#C8D2DE] px-4 py-2 text-base text-[#253747] disabled:opacity-75"
            }>
            Cancel
          </button>
          <button
            onClick={() => {
              onSubmit();
            }}
            className={
              "flex h-[35px] w-full items-center justify-center rounded-lg bg-[#7c66f0] px-4 py-2 text-base text-white disabled:opacity-75"
            }>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};
